import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';

export const BackMenu = (props) => {
	const { onSidebarOpen } = props;
	return (
		<IconButton
			id="menu-icon"
			onClick={onSidebarOpen}
			sx={{
				display: {
					cursor: 'pointer',
				},
			}}
		>
			<MenuIcon fontSize="small" />
		</IconButton>
	);
};

BackMenu.propTypes = {
	onSidebarOpen: PropTypes.func,
};
